import { useState } from "react";
import { TCheckText } from "src/app/types/CheckText";
import { ContentTransport } from "src/app/transports/content";

const useCheckText = () => {
    const [error, setError] = useState<any>();
    const [checkResult, setCheckResult] = useState<TCheckText>();
    const [loading, setLoading] = useState(false);

    const checkText = (text: string, guideId?: number) => {
        setLoading(true);
        ContentTransport.checkText(text, guideId)
            .then((res) => setCheckResult(res))
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    return {
        checkResult,
        checkText,
        error,
        loading,
    };
};

export default useCheckText;
